import React, { Component, Fragment } from 'react'
import PlaceHolder from 'components/PlaceHolder';
import {
	VEHICLE_TYPE
} from 'utils/constants';
import './VehicleDetails.scss'

export default class VehicleDetailsPlaceholder extends Component {

	render() {
		return (
		<Fragment>
			<div className="VehicleDetails">
				<div className="VehicleDetails__header">
					<h1 id="VehicleBasicInformationTitle" className="VehicleDetails__header__title"><PlaceHolder />
						<span id="VehicleBasicInformationDescription" className="VehicleDetails__header__description"><PlaceHolder /></span>
					</h1>
				</div>
				<div className="VehicleDetails__container">
					<table class="VehicleDetails__table">
						<tbody>
							{ VEHICLE_TYPE.car == this.props.vehicleType ?
								<Fragment>
                  <tr class="VehicleDetails__table__row">
                    <td class="VehicleDetails__table__column">
											<span class="VehicleDetails__table__column__title">Cidade</span>
											<strong class="VehicleDetails__table__column__value"><PlaceHolder/></strong>
										</td>
                  </tr>
									<tr class="VehicleDetails__table__row">
										<td class="VehicleDetails__table__column">
											<span class="VehicleDetails__table__column__title">Ano</span>
											<strong class="VehicleDetails__table__column__value"><PlaceHolder/></strong>
										</td>
										<td class="VehicleDetails__table__column">
											<span class="VehicleDetails__table__column__title">KM</span>
											<strong class="VehicleDetails__table__column__value"><PlaceHolder/></strong>
										</td>
									</tr>
									<tr class="VehicleDetails__table__row">
										<td class="VehicleDetails__table__column">
											<span class="VehicleDetails__table__column__title">Câmbio</span>
											<strong class="VehicleDetails__table__column__value"><PlaceHolder/></strong>
										</td>
										<td class="VehicleDetails__table__column">
											<span class="VehicleDetails__table__column__title">Carroceria</span>
											<strong class="VehicleDetails__table__column__value"><PlaceHolder/></strong>
										</td>
									</tr>
									<tr class="VehicleDetails__table__row">
										<td class="VehicleDetails__table__column">
											<span class="VehicleDetails__table__column__title">Combustível</span>
											<strong class="VehicleDetails__table__column__value"><PlaceHolder/></strong>
										</td>
										<td class="VehicleDetails__table__column">
											<span class="VehicleDetails__table__column__title">Final de placa</span>
											<strong class="VehicleDetails__table__column__value"><PlaceHolder/></strong>
										</td>
									</tr>
									<tr class="VehicleDetails__table__row">
										<td class="VehicleDetails__table__column">
											<span class="VehicleDetails__table__column__title">Cor</span>
											<strong class="VehicleDetails__table__column__value"><PlaceHolder/></strong>
										</td>
									</tr>
								</Fragment>
								:
								<Fragment>
                  <tr class="VehicleDetails__table__row">
                    <td class="VehicleDetails__table__column">
											<span class="VehicleDetails__table__column__title">Cidade</span>
											<strong class="VehicleDetails__table__column__value"><PlaceHolder/></strong>
										</td>
                  </tr>
									<tr class="VehicleDetails__table__row">
										<td class="VehicleDetails__table__column">
											<span class="VehicleDetails__table__column__title">Ano</span>
											<strong class="VehicleDetails__table__column__value"><PlaceHolder/></strong>
										</td>
										<td class="VehicleDetails__table__column">
											<span class="VehicleDetails__table__column__title">Marchas</span>
											<strong class="VehicleDetails__table__column__value"><PlaceHolder/></strong>
										</td>
									</tr>
									<tr class="VehicleDetails__table__row">
										<td class="VehicleDetails__table__column">
											<span class="VehicleDetails__table__column__title">Quilometragem</span>
											<strong class="VehicleDetails__table__column__value"><PlaceHolder/></strong>
										</td>
										<td class="VehicleDetails__table__column">
											<span class="VehicleDetails__table__column__title">Tipo de motor</span>
											<strong class="VehicleDetails__table__column__value"><PlaceHolder/></strong>
										</td>
									</tr>
									<tr class="VehicleDetails__table__row">
										<td class="VehicleDetails__table__column">
											<span class="VehicleDetails__table__column__title">Cor</span>
											<strong class="VehicleDetails__table__column__value"><PlaceHolder/></strong>
										</td>
										<td class="VehicleDetails__table__column">
											<span class="VehicleDetails__table__column__title">Refrigeração</span>
											<strong class="VehicleDetails__table__column__value"><PlaceHolder/></strong>
										</td>
									</tr>
									<tr class="VehicleDetails__table__row">
										<td class="VehicleDetails__table__column">
											<span class="VehicleDetails__table__column__title">Estilo</span>
											<strong class="VehicleDetails__table__column__value"><PlaceHolder/></strong>
										</td>
										<td class="VehicleDetails__table__column">
											<span class="VehicleDetails__table__column__title">Cilindrada</span>
											<strong class="VehicleDetails__table__column__value"><PlaceHolder/></strong>
										</td>
									</tr>
									<tr class="VehicleDetails__table__row">
										<td class="VehicleDetails__table__column">
											<span class="VehicleDetails__table__column__title">Partida</span>
											<strong class="VehicleDetails__table__column__value"><PlaceHolder/></strong>
										</td>
										<td class="VehicleDetails__table__column">
											<span class="VehicleDetails__table__column__title">Freio dianteiro /traseiro</span>
											<strong class="VehicleDetails__table__column__value"><PlaceHolder/></strong>
										</td>
									</tr>
									<tr class="VehicleDetails__table__row">
										<td class="VehicleDetails__table__column">
											<span class="VehicleDetails__table__column__title">Alimentação</span>
											<strong class="VehicleDetails__table__column__value"><PlaceHolder/></strong>
										</td>
									</tr>
								</Fragment>
							}
						</tbody>
					</table>

				</div>
				<div className="VehicleDetails__container">

					<div className="VehicleDetails__more-items">
                    	<h2 className="VehicleDetails__more-items__title">Sobre {this.props.vehicleType == VEHICLE_TYPE.car ? 'este carro' : 'esta moto'}</h2>
					</div>
					<p className="VehicleDetails__container__description-about"><PlaceHolder/></p>
				</div>
			</div>
		</Fragment>
		)
	}
}
